<app-check-overview-atom
  [check]="(checkDetailsVm$ | async)?.check ?? loadingCheck"
></app-check-overview-atom>
